import './App.css';
import { Analytics } from "@vercel/analytics/react";

function App() {

  const specLines = [
    "> specs --cpu",
    " AMD Ryzen 7 7700X",
    "> specs --ram",
    " 32GB DDR5",
    "> specs --gpu",
    " RTX 4070 Ti Super (16GB OC)",
    "> specs --disk",
    " 1TB M.2 + 2TB HDD",
    "> specs --os",
    " Windows 11 + Nyarch Linux",
    "> specs --monitor",
    " AOC 165Hz + BenQ 60Hz",
    "> specs --kb",
    " Logitech G413 TKL SE",
    "> specs --mouse",
    " Logitech G502 Hero"
  ];

  return (
    <div>
      <div className="bg"></div>
      <div className="main-container">
        <div className="profile-container">
          <div className="profile">
            <div id="pfp" style={{backgroundImage: process.env.PUBLIC_URL + "/nowepfp.jpg"}}></div>
            <div id="name">VerdiX094</div>
          </div>
          <div id="pronouns">(he/him)</div>
        </div>
        <div id="about">
          <div>Hi! I'm VerdiX (formerly known as N2O4) - a Polish software/mod developer, osu! player, and your typical weeb.</div>
          <div>I mostly specialize in Unity game development and modding (the latter especially for SFS), and ocassionally will code in pure C# or Python.</div>
          <div>I read almost 100% of my DMs and pings (I'm the type of guy who keeps his ping counter on the discord icon at 0), so if I didn't respond to yours, it's most likely because I forgot to, feel free to poke me.</div>
        </div>
        <div id="skills">
          <div className="code">
            <div style={{color:"#4080ff"}}>{"> languages --skip-unused"}</div>
          </div>
          <div id="languageContainer">
            <div className="languageIcon">
              <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/csharp/csharp-original.svg" alt="C#" />
              <div className="tooltip">
                C#
              </div>
            </div>
            <div className="languageIcon">
              <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/unity/unity-original.svg" alt="Unity" />
              <div className="tooltip">
                Unity
              </div>
            </div>
            <div className="languageIcon">  
              <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg" alt="React" />
              <div className="tooltip">
                React
              </div>
            </div>
            <div className="languageIcon">
              <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original.svg" alt="Python" />
              <div className="tooltip">
                Python
              </div>
            </div>
            <div className="languageIcon"> 
              <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/java/java-plain.svg" alt="Java" />
              <div className="tooltip">
                Java
              </div>
            </div>
          </div>
        </div>
        <div id="specs-links-container">
          <div id="specs">
            {specLines.map(line => (
              <div className="spec code" key={line}>
                {line.startsWith("> ") && <div style={{color:"#4080ff"}}>{line}</div>}
                {!line.startsWith("> ") && <div>{line}</div>}
              </div>
            ))}
          </div>
          <div id="links">
            <a href="https://osu.ppy.sh/users/33722049" target="blank">
              <div id="osu" className="icon">
                <div className="tooltip">
                  VerdiX
                </div>
              </div>
            </a>
            <a href="https://github.com/VerdiX094" target="blank">
              <div id="github" className="icon">
                <div className="tooltip">
                  VerdiX094
                </div>
              </div>
            </a>
            <div id="discord" className="icon">
              <div className="tooltip">
                verdix094
              </div>
            </div>
          </div>
        </div>
        (yes i know its ugly 😭)
      </div>
      <Analytics/>
    </div>
  );
}

export default App;
